import { ISelectValue } from '@/@types'
import { Payment } from '@/@types/payment'
import { DatePicker } from '@/components'
import { DataTableFacetedFilter } from '@/components/data-table/faceted-filter'
import { useBillsStore } from '@/stores/bills'
import { Table } from '@tanstack/react-table'
import { useCallback, useMemo } from 'react'

interface Props {
  table?: Table<Payment>
}

export function TableToolbar({ table }: Props) {
  const { startDate, endDate, setStartDate, setEndDate } = useBillsStore()

  const LEVELS: ISelectValue[] = useMemo(
    () => [
      { label: 'Nível 1', value: '1' },
      { label: 'Nível 2', value: '2' },
      { label: 'Nível 3', value: '3' },
      { label: 'Nível 4', value: '4' },
      { label: 'Nível 5', value: '5' },
    ],
    [],
  )

  const handleStartDateChange = useCallback(
    (date: string) => setStartDate(date),
    [setStartDate],
  )
  const handleEndDateChange = useCallback(
    (date: string) => setEndDate(date),
    [setEndDate],
  )

  if (!table) return null

  return (
    <>
      <DataTableFacetedFilter
        title="Nível"
        table={table}
        columnId="user.level"
        options={LEVELS}
      />

      <DatePicker
        label="Data de Início"
        defaultDate={startDate}
        onChange={handleStartDateChange}
      />

      <DatePicker
        label="Data de Fim"
        defaultDate={endDate}
        onChange={handleEndDateChange}
      />
    </>
  )
}
